module.exports = __webpack_public_path__ + "img/blogs_dark_blue.53f02770.png";